/**
 * This file is auto-generated
 */
export const accountSettingsUsersGatewayMethods = [
    'getInfo',
    'getUsers',
    'getRoles',
    'getOrganizations',
    'updateUser',
    'deleteUser',
    'invite',
    'revoke',
];
//# sourceMappingURL=api.js.map